import { createLazyComponent, LazyAction, LazyModule } from 'owa-bundling';

export { getStore as getRelatedContentStore } from './store/store';
export { default as RelatedContentInsights } from './components/RelatedContentInsights';
export { default as areInsightsAvailable } from './selectors/areInsightsAvailable';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "RelatedContent" */ './lazyIndex')
);

export const lazySetHasScrolledInDetailsForm = new LazyAction(
    lazyModule,
    m => m.setHasScrolledInDetailsForm
);
export const lazyResetRelatedContentViewState = new LazyAction(
    lazyModule,
    m => m.resetRelatedContentViewState
);
export const lazyTryFetchRelatedContentInsights = new LazyAction(
    lazyModule,
    m => m.tryFetchRelatedContentInsights
);
export const RelatedEmailsWell = createLazyComponent(lazyModule, m => m.RelatedEmailsWell);
export const RelatedFilesWell = createLazyComponent(lazyModule, m => m.RelatedFilesWell);
export const MeetingInsightsButton = createLazyComponent(lazyModule, m => m.MeetingInsightsButton);
